import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { ModalGenericoModel } from 'src/app/shared/models/modal.model';
import { RntService } from '../../containers/bandeja-principal/funcionario/rnts/rnt.service';
import { AlertsService } from '../../../../shared/services/alerts.service';
import { MensajesUsuario } from 'src/app/shared/enumeraciones/mensajes-usuario.enum';

@Component({
  selector: 'app-modal-historial-detalle-proceso',
  templateUrl: './modal-historial-detalle-proceso.component.html',
	styleUrls: ['./modal-historial-detalle-proceso.component.scss']
})
export class ModalHistorialDetalleProcesoComponent implements OnInit {
  
  detalleProceso: DatoPaginadoModel;
  @Input()
  rntId: number;
  prueba: Array<any>;
  headers: Array<string>;
  dataTabla: DatoPaginadoModel;
  modalGenerico: ModalGenericoModel;
	paginaActual: number;

  constructor(
    private activeModal: NgbActiveModal,
    private rntService: RntService,
    private alertService: AlertsService
  ) {
    this.detalleProceso = {
			paging: {} as Paging
		} as DatoPaginadoModel;

    this.paginaActual = 1;
  }

  ngOnInit(): void {
    this.headers = ['Usuario de creación', 'Fecha de creación', 'Número radicado', 'Tipo solicitud',
    'Tipo anotación', 'Días de gestión', 'Días límites', 'Día de diferencia'];

    this.modalGenerico = {
			titulo: 'Detalle del proceso'
		};
    this.search();
  }

  confirm(): void {
    this.activeModal.close();
  }

  onPaginado(value: number){
    this.paginaActual = value;
    this.search();
  }
  search(): void{
    this.rntService.historialDetalleProceso(this.rntId,this.paginaActual).subscribe((response) => {
		  if(response.result){
			let detalleProceso = response.data.items;
			if(detalleProceso.length > 0){
			  for(let i =0; i < detalleProceso.length; i++){
				let temp = detalleProceso[i];
	
				if(temp.dias_gestion > temp.dias_limite){
				  response.data.items[i].class = 'expiredDay';
				}
			  }
	
			  let dataTable = response.data as DatoPaginadoModel;
        this.detalleProceso = dataTable;
			} else{
			  this.alertService.info(
				MensajesUsuario.NoDataFound,
				null,
				null
			  );
			}
		  } else{
			this.alertService.error(
			  MensajesUsuario.Errorgeneral,
			  null,
			  null
			);
		  }
		});
  }
}
